import { Component, OnInit } from '@angular/core';
import { LoaderService } from './loader.service';
import {MatProgressBarModule} from '@angular/material/progress-bar';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit  {
  showLoader: boolean;
  color = 'primary';
  mode = 'indeterminate';
  constructor(public loaderService: LoaderService) {
}

public ngOnInit(): void {
  this.loaderService.status.subscribe((val: boolean) => {
    this.showLoader = val;
    // console.log('En el init de component');
  });

}


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts